// Vart i hela fridens namn används den här?
// Addresses page
// Project details
// Workorder list (som kommer ifrån workOrderPerProject)

import { ProjectBase } from './base-classes/project-base'

const projectBase = new ProjectBase()

projectBase.state.all.defaultFilter = {
  showAll: false,
  projectCode: '',
  projectOwnerUserInitials: '',
  projectReviewerUserInitials: '',
  tags: [],
  orderByColumn: 'projectCode',
  orderByDescending: true
}

export const projects = {
  namespaced: true,
  state: projectBase.state,
  actions: projectBase.actions(),
  mutations: projectBase.mutations(),
  getters: projectBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/project.module.js